import React from "react";
import { Control } from "react-hook-form";

import Divider from "components/ui/divider/Divider";
import Tooltip from "components/ui/tooltip/Tooltip";
import RedactedWrapper from "../../../lib/core_components/RedactedWrapper";
import { FrameworkSelect } from "../../form_components/FrameworkSelect";
import { Radio } from "../../form_components/Inputs";
import { FrameworkFilterOptions } from "../../record_search/types";
import { NoticeFilters } from "../utils";

import css from "./Frameworks.module.scss";

export interface FrameworksFilterContentProps {
  control: Control<NoticeFilters, unknown>;
}

function FrameworksFilterContent({ control }: FrameworksFilterContentProps) {
  return (
    <div className={css.filterSection} aria-label="Framework filters">
      <FrameworkSelect
        name="frameworkIds"
        label=""
        control={control}
        mode="multiple"
        placeholder="Search frameworks..."
        allowClear
        enablePortal
      />
      <Divider />
      <RedactedWrapper
        redactContent={
          <Radio
            label=""
            name="frameworkFilterOptions"
            control={control}
            disabled
            options={[
              { label: "Include all framework activity", value: "" },
              {
                label: (
                  <Tooltip
                    side="left"
                    sideOffset={32}
                    content="Show only call-offs that relate to frameworks agreements"
                  >
                    <span>Show only call-offs</span>
                  </Tooltip>
                ),
                value: FrameworkFilterOptions.SHOW_ONLY_FRAMEWORK_CALL_OFFS,
              },
              {
                label: (
                  <Tooltip
                    side="left"
                    sideOffset={32}
                    content="Show only notices relating to the creation of framework agreements. Call-offs and non-framework notices will be hidden."
                  >
                    <span>Show only framework agreements</span>
                  </Tooltip>
                ),
                value: FrameworkFilterOptions.SHOW_ONLY_FRAMEWORK_AGREEMENTS,
              },
              {
                label: (
                  <Tooltip
                    side="left"
                    sideOffset={32}
                    content="Any pre-tenders, tenders or contract awards that relate to the creation of a framework will be hidden. Call-offs within frameworks will still appear."
                  >
                    <span>Hide framework agreement notices</span>
                  </Tooltip>
                ),
                value: FrameworkFilterOptions.HIDE_FRAMEWORK_AGREEMENT_NOTICES,
              },
              {
                label: (
                  <Tooltip
                    side="left"
                    sideOffset={32}
                    content="Any notices relating to framework agreements and their underlying call-offs will be hidden."
                  >
                    <span>Hide all framework activity</span>
                  </Tooltip>
                ),
                value: FrameworkFilterOptions.HIDE_ALL_FRAMEWORK_ACTIVITY,
              },
            ]}
            optionType="default"
            direction="vertical"
          />
        }
        // TODO: Add framework paywall here
        //   requiredDataType="SUPPLIERS"
        contextSource="Framework activity type filter"
      >
        <Radio
          label=""
          name={"frameworkFilterOptions"}
          control={control}
          options={[
            { label: "Include all framework activity", value: "" },
            {
              label: (
                <Tooltip
                  side="left"
                  sideOffset={32}
                  content="Show only call-offs that relate to frameworks agreements"
                >
                  <span>Show only call-offs</span>
                </Tooltip>
              ),
              value: FrameworkFilterOptions.SHOW_ONLY_FRAMEWORK_CALL_OFFS,
            },
            {
              label: (
                <Tooltip
                  side="left"
                  sideOffset={32}
                  content="Show only notices relating to the creation of framework agreements. Call-offs and non-framework notices will be hidden."
                >
                  <span>Show only framework agreements</span>
                </Tooltip>
              ),
              value: FrameworkFilterOptions.SHOW_ONLY_FRAMEWORK_AGREEMENTS,
            },
            {
              label: (
                <Tooltip
                  side="left"
                  sideOffset={32}
                  content="Any pre-tenders, tenders or contract awards that relate to the creation of a framework will be hidden. Call-offs within frameworks will still appear."
                >
                  <span>Hide framework agreement notices</span>
                </Tooltip>
              ),
              value: FrameworkFilterOptions.HIDE_FRAMEWORK_AGREEMENT_NOTICES,
            },
            {
              label: (
                <Tooltip
                  side="left"
                  sideOffset={32}
                  content="Any notices relating to framework agreements and their underlying call-offs will be hidden."
                >
                  <span>Hide all framework activity</span>
                </Tooltip>
              ),
              value: FrameworkFilterOptions.HIDE_ALL_FRAMEWORK_ACTIVITY,
            },
          ]}
          optionType="default"
          direction="vertical"
        />
      </RedactedWrapper>
    </div>
  );
}

export default FrameworksFilterContent;
